<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
<!--      <div class="col-xl-3">-->
<!--        <BranchStatsPanel />-->
<!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create Internal Account</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreateInternalAccountForm></CreateInternalAccountForm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Create Internal Account",
    meta: [{ name: "Create Internal Account", content: window.__env.app.description }]
  },

  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "CreateInternalAccount",
      title: "Create Internal Account",
      items: [
        {
          text: "Internal Account",
          href: "/"
        },
        {
          text: "Create Internal Account",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
